module.exports = __webpack_public_path__ + "img/iStock-1162000526.c3e60704.jpg";